import * as React from "react";
import {Image} from "react-bootstrap";
import {useBrandQuery} from "../../../hooks/useBrandQuery";

export const BrandLogo = () => {
    const {model: {brand: {description, link, image}}} = useBrandQuery();

    // If there is no brand, don't render anything.
    if (!image) return <></>;

    const imageElement = (
        <Image
            src={image.url}
            alt={image.alt}
            title={image.title}
            width="210"
            height="48"
            className="img-fluid" 
            loading="lazy"
            decoding="async"/>
    )

    return (
        <div>
            <div className="product-brand my-3">
                {link ? (
                    <a href={link} target="_blank" className="d-block"  tabIndex={0} role="link" aria-label="Link to Displays2Go.com homepage">
                        {imageElement}
                    </a>
                ) : (
                    <>
                        {imageElement}
                    </>
                )}
                {description && <p className="text-muted">{description}</p>}
            </div>
            <hr className="text-muted" />
        </div>
    );
};